import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  ListItemIcon,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { onGetDonations, onGetDonationTypes } from "../../src/utils/queries";

const TypeFilter = ({ setFilter, value, setValue, setNames }) => {
  const [textBox, setTextBox] = useState("");
  const [open, setOpen] = React.useState(false);

  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([...list]);
  const filterRef = React.useRef();
  const { isLoading, isSuccess, error, isError, data } = onGetDonationTypes();

  useEffect(() => {
    if (isSuccess) {
      const types = data.data.data;
      setList(types);
    }
  }, [isSuccess]);

  const getTypes = list.map((listItem) => listItem.type);

  useEffect(() => {
    const filter = list.filter((item) => {
      if (!textBox) return list;
      return item.type.toLowerCase().includes(textBox.toLowerCase());
    });

    setFilteredList(filter);
  }, [textBox, list]);

  const handleChange = (event) => {
    const getId = list.map((listItem) => listItem.id);
    const filterH = event.target.value.map((item) => {
      if (getId.indexOf(item) > -1) {
        return list[getId.indexOf(item)].type;
      }
    });
    setNames(filterH);
    setValue((prev) => ({
      ...prev,
      donation_type: event.target.value,
    }));
    setFilter((prev) => ({
      ...prev,
      donation_type: !event.target.value.length
        ? undefined
        : event.target.value.join(","),
      page: 1,
    }));
  };

  const handleList = (event) => {
    event.preventDefault();
    setTextBox(event.target.value);
  };

  const stopPropagation = (e) => {
    switch (e.key) {
      case "ArrowDown":
      case "ArrowUp":
      case "Home":
      case "End":
        break;
      default:
        e.stopPropagation();
    }
  };
  const moveFocusToInput = (e) => {
    if (e.key === "Tab" || e.key === "ArrowRight") {
      e.stopPropagation();
      e.preventDefault();
      filterRef.current.focus();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <FormControl>
      <Select
        autoWidth
        displayEmpty
        size="small"
        multiple
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        value={value.donation_type}
        renderValue={(selected) => {
          const index = selected.indexOf("");
          if (index > -1) {
            selected.splice(index, 1); // 2nd parameter means remove one item only
          }
          if (selected.length === 0) {
            return <Typography variant="big">Donation type</Typography>;
          }

          const getId = list.map((listItem) => listItem.id);
          const filterH = selected.map((item) => {
            if (getId.indexOf(item) > -1) {
              return list[getId.indexOf(item)].type;
            }
          });

          return filterH.join(" ,");
        }}
        sx={{
          borderRadius: "16px",
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              boxShadow: "none",
              border: "1px solid",
              borderColor: "grey.main",
            },
          },
        }}
        onChange={(event) => handleChange(event)}
        id="demo-simple-select"
      >
        <MenuItem disabled>SELECT ONE OR MORE</MenuItem>
        <TextField
          placeholder="Filter"
          inputRef={filterRef}
          sx={{
            border: "none",
            borderColor: "",
            fontSize: "14px",
            marginBottom: "0.5em",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "grey.border40",
              },
              "&.Mui-focused fieldset": {
                borderColor: "primary.main",
              },
            },
          }}
          value={textBox}
          size="small"
          onKeyDown={stopPropagation}
          onChange={handleList}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <i className="las la-search la-lg"></i>
              </InputAdornment>
            ),
          }}
        />
        {/* </MenuItem> */}
        {filteredList.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            <ListItemIcon>
              {value.donation_type.includes(item.id) && (
                <i
                  className="las la-check la-md"
                  style={{ color: "#2962ff" }}
                ></i>
              )}
            </ListItemIcon>
            {item.type}
          </MenuItem>
        ))}
        <Box p={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            Close
          </Button>
        </Box>
      </Select>
    </FormControl>
  );
};

export default TypeFilter;
